<template>
    <div class="page-container">
        <a-tabs v-model:activeKey="activeKey" class="overflow-y-scroll" style="background: #fff;" type="card">
            <a-tab-pane key="1" tab="专用备件">
                <dev-bpbj-standard-zy-info ref="DevBpbjStandardZyInfo"></dev-bpbj-standard-zy-info>
            </a-tab-pane>
            <a-tab-pane key="2" tab="其他">
                <dev-bpbj-standard-qt-info ref="DevBpbjStandardQtInfo"></dev-bpbj-standard-qt-info>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>
    import DevBpbjStandardZyInfo from './DevBpbjStandardZyInfo.vue'
    import DevBpbjStandardQtInfo from './DevBpbjStandardQtInfo.vue'
    export default {
        name: "DevBpbjStandardInfoList",
        components: {
            DevBpbjStandardZyInfo,
            DevBpbjStandardQtInfo
        },
        data() {
            return {
                description: '备品备件标准库管理页面',
                activeKey: '1',
            }
        },
        created() {},
        computed: {},
        methods: {
        }
    }
</script>
<style scoped>

    @import '~@assets/less/common.less';

</style>